import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WidgetValidator} from '@pt/pt-models';
import {ValidatorGenerator} from '../../utils/validator-generator';

@Component({
  selector: 'pt-treatment-input',
  templateUrl: './treatment-input.component.html',
  styleUrls: ['./treatment-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TreatmentInputComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => TreatmentInputComponent),
      multi: true
    }
  ]
})
export class TreatmentInputComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() controlName: string;
  @Input() validators: WidgetValidator[];
  @Input() inputLink: boolean = false; // se settato a true viene emesso al click l'evento clickInput e non è modificabile
  @Input() label: string;
  @Input() placeholder: string;
  @Input() help: string;
  @Input() error: string;    // Da implementare
  @Input() enabledEdit: boolean;

  @Input() type: 'text' | 'number' = 'text';
  @Output() enableEdit = new EventEmitter();
  @Output() saveChange = new EventEmitter();
  @Output() clickInput = new EventEmitter();
  @Output() reset = new EventEmitter();


  public formGroup: FormGroup;
  isDisabled = false;
  isChanged = false;
  isRequired: boolean;
  inputId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  clickReset() {
    this.reset.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'ptWTreatmentInputText_' + this.controlName;

    this.isRequired = ValidatorGenerator.validatorsContainsRequired(this.validators);

    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChanged = t.value !== null;

      if (this.onChanged) {
        this.onChanged(t ? t.value : t);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  writeValue(obj: any): void {
    this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    const validator = ValidatorGenerator.generateValidator(this.validators);
    this.formGroup = new FormGroup({
      value: new FormControl(null, validator)
    });
  }
}
